import { render, staticRenderFns } from "./UserChip.vue?vue&type=template&id=961254ac&scoped=true&"
import script from "./UserChip.vue?vue&type=script&lang=ts&"
export * from "./UserChip.vue?vue&type=script&lang=ts&"
import style0 from "./UserChip.vue?vue&type=style&index=0&id=961254ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "961254ac",
  null
  
)

export default component.exports